import { NgModule } from '@angular/core';
import { DropdownModule } from 'primeng/dropdown';
import { RadioButtonModule } from 'primeng/radiobutton';
import { TableModule } from 'primeng/table';
import { DialogModule } from 'primeng/dialog';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { CoreModule } from '../core/core.module';
import { OutlyingPointComponent } from './outlying-point.component';
import { OutlyingPointDataComponent } from './data/outlying-point-data.component';
import { OutlyingPointService } from './services/outlying-point-service';
import { OutlyingPointResolver } from './shared/outlying-point.resolver';
import { FormsModule } from '@angular/forms';
import { OutlyingRoutingModule } from './outlying-point-routing.module';
import { OutlyingPointHeaderComponent } from './data/outlying-point-header/outlying-point-header.component';
import { OutlyingPointDisplayDataComponent } from './data/outlying-point-display-data/outlying-point-display-data.component';

/**
 * @export
 * @class OutlyingPointModule
 */
@NgModule({
  imports: [
    CommonModule,
    OutlyingRoutingModule,
    DropdownModule,
    DialogModule,
    RadioButtonModule,
    TableModule,
    SharedModule,
    CoreModule,
    FormsModule
  ],
  providers: [OutlyingPointService, OutlyingPointResolver],
  declarations: [OutlyingPointComponent, OutlyingPointDataComponent, OutlyingPointHeaderComponent, OutlyingPointDisplayDataComponent],
  exports: [OutlyingPointComponent]
})
export class OutlyingPointModule { }
